/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValuesForColumn
 */
export interface ValuesForColumn {
    /**
     * 
     * @type {string}
     * @memberof ValuesForColumn
     */
    key: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValuesForColumn
     */
    values: Array<string>;
}


/**
 * Check if a given object implements the ValuesForColumn interface.
 */
export function instanceOfValuesForColumn(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "key" in value;
    isInstance = isInstance && "values" in value;

    return isInstance;
}

export function ValuesForColumnFromJSON(json: any): ValuesForColumn {
    return ValuesForColumnFromJSONTyped(json, false);
}

export function ValuesForColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValuesForColumn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': json['key'],
        'values': json['values'],
    };
}

export function ValuesForColumnToJSON(value?: ValuesForColumn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'values': value.values,
    };
}

